"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemberList = void 0;
const i18next_1 = require("i18next");
const react_1 = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const common_1 = require("../../../../common");
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const popup_1 = require("../../../base/popup");
const ChoiceMemberTable_1 = require("./ChoiceMemberTable");
const constant_1 = require("../constant");
const MemberListTableStyled_1 = require("./MemberListTableStyled");
const SMSUploadExcel_1 = require("./SMSUploadExcel");
const SendMemberHeader_1 = require("./SendMemberHeader");
const server_1 = require("../../../../server");
const lodash_1 = __importStar(require("lodash"));
const classes_1 = require("../../../base/classes");
const DeletePopUpLayout_1 = require("../../../base/layout/DeletePopUpLayout");
const MemberListStyled = styled_components_1.default.div `
	gap: 12px;

	.btn-container {
		flex-direction: column;
		justify-content: center;

		.btn_line_light_tur {
			color: var(--color-tur, #3ab2bf);
		}
	}

	.disable {
		background-color: var(--color-grey-c, #e6e8ed);
	}

	.excel-wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
		flex: 1;
	}

	.member-setting {
		display: flex;
		flex-wrap: wrap;
		flex-direction: row;
		gap: 12px;
		flex-shrink: 0;
		align-items: center;
		width: 100%;
	}

	.file-item-wrap {
		padding: 8px !important;

		button {
			padding: 1px 8px !important;
		}
		p {
			line-height: 22px !important;
		}
	}

	${props => (!props.$isMobile ? desktopStyles : mobileStyles)}
`;
const mobileStyles = (0, styled_components_1.css) `
	display: flex;
	flex-direction: column;
	gap: 12px;

	.member-list {
		width: 100%;
		gap: 16px;
		display: flex;
		flex-direction: column;
	}

	.member-setting {
		display: flex;
		flex-direction: column;
		gap: 10px;
		flex-shrink: 0;
		align-items: flex-start;
		width: 100%;
		height: fit-content;

		.checkboxk {
			gap: 8px;
		}
	}
		
	.frame-987338 {
		display: flex;
		flex-direction: row;
		gap: 12px;
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
	}

	.open-header {
		border-style: solid;
		border-color: var(--color-grey-c, #e6e8ed);
		border-width: 0px 0px 1px 0px;
		padding: 0px 0px 12px 0px;
		display: flex;
		flex-direction: row;
		gap: 12px;
		align-items: center;
		justify-content: space-between;
		flex-shrink: 0;
		position: relative;
	}
	.title-name {
		color: var(--color-black, #101010);
		text-align: left;
		font-family: var(--h5-font-family, 'Noto Sans KR', sans-serif);
		font-size: var(--h5-font-size, 16px);
		line-height: var(--h5-line-height, 24px);
		letter-spacing: var(--h5-letter-spacing, -0.02em);
		font-weight: var(--h5-font-weight, 700);
		position: relative;
		width: 248px;
	}

	.member-table-wrap {
		display: flex;
		flex-direction: column;
		gap: 12px;
		flex: 1;
		overflow: hidden;

		.paging {
			padding-top: 0 !important;
		}
	}
	.header {
		display: flex;
		flex-direction: column;
		gap: 12px;
	}

	.user-list {
		width: 100%;
		flex: 1;
		overflow: hidden;
	}

	.select-members-wrap {
		display: flex;
		flex-direction: row;
		gap: 12px;
		row-gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
	}
	.select-members {
		background: #ecf7f8;
		border-radius: 12px;
		padding: 20px 0px 20px 0px;
		display: flex;
		flex-direction: column;
		gap: 4px;
		row-gap: 0px;
		align-items: center;
		justify-content: center;
		flex: 1;
		position: relative;
	}

	.button {
		p {
			font-size: 12px;
		}
	}

	.btn_line_light_tur {
		p {
			color: var(--color-black, #101010);
		}
	}

	.mobile-full {
		border-radius: 6px;
		justify-content: center;

		p {
			justify-content: center;
			width: unset;
		}

		&.text-tur {
			p {
				color: var(--tur, #3ab2bf);
			}
		}

		&.text-pink {
			p {
				color: var(--color-pink, #f46790);
			}
		}
	}

	.setting-checkbox {
		display: flex;
		flex-direction: column;
		gap: 4px;
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
	}

	.substitute-input {
		text-align: center !important;
	}
`;
const desktopStyles = (0, styled_components_1.css) `

	.header {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
		gap: 40px;

		${props => props.$isTablet && `
			button {
				padding: 8px;
			}	
		`}
	}

	.member-list {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		gap: ${props => (props.$isTablet ? '16px' : '24px')};
		overflow: hidden;
	}

	.user-list {
		width: 100%;
		height: 100%;
		min-height: ${props => (props.$isTablet ? '250px' : '300px')};
	}

	.btn-container {
		margin: auto 0;
		.md_round {
			padding: 4px 18px;
			p {
				min-width: unset;
				line-height: var(--b4-line-height, 28px);
			}
		}
	}

	.member-wrap {
		display: flex;
		height: 100%;
		gap: 20px;
	}

	.setting-checkbox {
		display: flex;
		flex-direction: row;
		gap: 12px;
		align-items: center;
		flex-shrink: 0;
	}

	.add-input {
		min-width: 56px;
	}

	.substitute-input {
		min-width: 56px;
	}
`;
exports.MemberList = react_1.default.memo(({ openMemberList, isNormal, substitutes, receiverMemberList, setReceiverMemberList, memberSetting, originalStudentData, everyStudentData, oneByOneData, excelUploadData, setMemberSetting, setOriginalStudentData, setEveryStudentData, setOneByOneData, setExcelUploadData, isOnlyStudent, setIsOnlyStudent, }) => {
    const { isMobile, isTablet, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const classesId = (0, classes_1.getClassesId)();
    const [page, setPage] = (0, react_1.useState)(0);
    const count = 10;
    const [testData, setTestData] = (0, react_1.useState)([]);
    const [noNumberData, setNoNumberData] = (0, react_1.useState)([]);
    const [totalCount, setTotalCount] = (0, react_1.useState)(0);
    const [checkList, setCheckList] = (0, react_1.useState)([]);
    // '수강생(전체)' 모드 여부
    const isEveryStudent = memberSetting === 'everyStudent';
    const [searchOption, setSearchOption] = (0, react_1.useState)({ keyword: undefined });
    const [inputValues, setInputValues] = (0, react_1.useState)(substitutes.map(type => ({ type, value: '' })));
    // 참가자 목록 가져오기
    const { data, refetch } = (0, server_1.useMemberInfo)({
        class_id: classesId,
        // status: 'created',
        ...(isOnlyStudent ? { level: ['03'] } : {}),
        // offset: page === 0 ? 0 : page * count,
    });
    // (리스트 갱신)
    const refetchList = (0, lodash_1.throttle)(() => refetch(), 1000, { leading: true, trailing: false });
    (0, react_1.useEffect)(() => {
        refetchList();
    }, []);
    (0, react_1.useEffect)(() => {
        setPage(0);
        refetchList();
    }, [isOnlyStudent]);
    (0, react_1.useEffect)(() => {
        if (openMemberList)
            return;
        if (isNormal) {
            setMemberSetting('everyStudent');
        }
        else {
            setMemberSetting('oneByOne');
        }
    }, [isNormal, openMemberList]);
    (0, react_1.useEffect)(() => {
        setTotalCount(0);
        setTestData([]);
        setReceiverMemberList([]);
        setSearchOption(prev => ({ ...prev, keyword: undefined }));
        if (memberSetting === 'everyStudent') {
            // '수강생(전체)'은 체크된 인원만 수신자로 전송한다.
            // 기본값: 페이지네이션과 무관하게 전체 인원 체크.
            const allIds = everyStudentData.map(item => item.id);
            setCheckList(allIds);
            setReceiverMemberList(everyStudentData);
        }
        else if (memberSetting === 'oneByOne') {
            // 다른 모드의 체크박스는 '선택 삭제'용이므로 기본 해제 상태.
            setCheckList([]);
            setReceiverMemberList(oneByOneData);
        }
        else if (memberSetting === 'excelUpload') {
            setCheckList([]);
            setReceiverMemberList(excelUploadData);
        }
    }, [memberSetting, everyStudentData, oneByOneData, excelUploadData]);
    // '수강생(전체)' 모드: 체크된 인원만 수신자 payload(receiverMemberList)에 반영.
    // (체크 인원수 = 수신자 인원 표기, send payload 기준)
    (0, react_1.useEffect)(() => {
        if (!isEveryStudent)
            return;
        setReceiverMemberList(everyStudentData.filter(item => checkList.includes(item.id)));
    }, [isEveryStudent, checkList, everyStudentData]);
    (0, react_1.useEffect)(() => {
        setPage(0);
    }, [memberSetting]);
    (0, react_1.useEffect)(() => {
        if (data) {
            const { total_count, found_count, items } = data;
            if (found_count === 0 && total_count > 0) {
                const maxPage = Math.max(0, Math.ceil(total_count / 10) - 1);
                setPage(maxPage);
            }
            if (total_count > 0) {
                const simpleItems = items.map(item => ({
                    id: item.id,
                    data: [
                        item.nickname + (item.identifier ? `(${item.identifier})` : ""),
                        item.phone_number.replace(/-/g, "")
                    ]
                }));
                setOriginalStudentData(simpleItems);
                setEveryStudentData(simpleItems.filter(item => item.data[1] !== ''));
                setTotalCount(total_count);
                return;
            }
        }
        setTestData([]);
        setTotalCount(0);
    }, [data]);
    (0, react_1.useEffect)(() => {
        const searchKeyword = searchOption.keyword?.trim().toLowerCase() || '';
        // '수강생(전체)'은 체크 여부와 무관하게 전체 인원을 노출해야 하므로
        // 테이블 데이터 소스로 전체 풀(everyStudentData)을 사용한다.
        // (수신자 payload는 체크된 인원만 담긴 receiverMemberList 사용)
        const sourceData = isEveryStudent ? everyStudentData : receiverMemberList;
        const filteredData = searchKeyword !== ''
            ? sourceData.filter(item => item.data[0]?.toLowerCase().includes(searchKeyword) ||
                item.data[1]?.replace(/-/g, '').includes(searchKeyword.replace(/-/g, '')))
            : sourceData;
        const startIndex = page * count;
        const endIndex = startIndex + count;
        const currentTestData = filteredData.slice(startIndex, endIndex);
        setNoNumberData(originalStudentData.filter(item => item.data[1] === '' || item.data[1] === '-'));
        setTestData(currentTestData);
        setTotalCount(filteredData.length);
    }, [searchOption, page, count, receiverMemberList, isEveryStudent, everyStudentData]);
    (0, react_1.useEffect)(() => {
        const handleAddSelectedMembers = ({ members, setting }) => {
            const setData = setting === "everyStudent"
                ? setEveryStudentData
                : setting === "oneByOne"
                    ? setOneByOneData
                    : null;
            if (setData) {
                setData((prev) => {
                    const originalIds = new Set(originalStudentData.map(member => member.id));
                    const filteredPrev = prev.filter(member => !originalIds.has(member.id));
                    return [...filteredPrev, ...members];
                });
            }
        };
        APP.eventManager.subscribe("ADD_SELECTED_MEMBERS", handleAddSelectedMembers);
        return () => {
            APP.eventManager.unsubscribe("ADD_SELECTED_MEMBERS", handleAddSelectedMembers);
        };
    }, [originalStudentData]);
    const handlerMoreData = (page) => {
        setPage(page);
    };
    const { headTitleList, tableReadDataKeys } = react_1.default.useMemo(() => {
        const headTitleList = [
            ...(!isMobile ? isNormal ?
                [
                    { title: 'nameId', space: 1, sort: false },
                    { title: 'phoneNumber', space: 3, sort: false },
                ] : [
                { title: 'nameId', space: 1, sort: false },
                { title: 'phoneNumber', space: 1, sort: false },
                { title: 'substitute1', space: 1, sort: false },
                { title: 'substitute2', space: 1, sort: false },
                { title: 'substitute3', space: 1, sort: false },
                { title: 'substitute4', space: 1, sort: false },
            ] : []),
        ];
        const tableReadDataKeys = isNormal ? [
            { title: 'nickname', space: 1, sort: false },
            { title: 'phone_number', space: 3, sort: false },
        ] : [
            { title: 'nickname', space: 1, sort: false },
            { title: 'phone_number', space: 1, sort: false },
            { title: 'substitute1', space: 1, sort: false },
            { title: 'substitute2', space: 1, sort: false },
            { title: 'substitute3', space: 1, sort: false },
            { title: 'substitute4', space: 1, sort: false },
        ];
        // useMemo에서 반환
        return { headTitleList, tableReadDataKeys };
    }, [isNormal, isMobile]);
    // 상단 레이아웃 검색 조건을 위한 action
    const handlerFilterList = (filter) => {
        setPage(0);
        setSearchOption(filter);
    };
    const onDelete = () => {
        const deleteMemberList = (data) => data.filter(item => !checkList.includes(item.id));
        const setDataFunction = {
            everyStudent: setEveryStudentData,
            oneByOne: setOneByOneData,
            excelUpload: setExcelUploadData,
        }[memberSetting];
        if (!setDataFunction)
            return;
        setDataFunction(prev => {
            let updatedList;
            updatedList = deleteMemberList(prev);
            setPage(updatedList.length > count ? Math.floor(updatedList.length / count) - 1 : 0);
            setTotalCount(updatedList.length);
            return updatedList;
        });
    };
    const handlerDelete = () => {
        if (checkList.length <= 0)
            return;
        if (isMobile) {
            onDelete();
        }
        else {
            APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
                component: DeletePopUpLayout_1.DeletePopUpLayout,
                componentProps: {
                    deleteContent: checkList.length
                        ? (0, i18next_1.t)('assignment.delteInto', { count: checkList?.length })
                        : (0, i18next_1.t)('common.notSelect'),
                    onDelete: onDelete,
                },
                width: 639,
                title: (0, i18next_1.t)(`sendSMS.deleteMember`),
                isFit: true,
            });
        }
    };
    const validatePhoneNumber = phoneNumber => {
        // 한국 전화번호 형식 검증: 010-1234-5678, 01012345678, 011-123-4567, 016-123-4567 등
        const phoneRegex = /^(01[016789]-?\d{3,4}-?\d{4})$/;
        return phoneRegex.test(phoneNumber);
    };
    //전화번호 추가
    const handlerAdd = () => {
        if (inputValues[0].value === '') {
            return alert((0, i18next_1.t)('sendSMS.enterName'));
        }
        if (!validatePhoneNumber(inputValues[1].value)) {
            return alert((0, i18next_1.t)('sendSMS.retypeNumber'));
        }
        if (receiverMemberList.some(item => item.data[1] === inputValues[1].value)) {
            return alert((0, i18next_1.t)('sendSMS.invalidPhoneNumber'));
        }
        const newMember = {
            id: inputValues[1].value,
            data: [
                inputValues[0].value,
                inputValues[1].value,
                inputValues[2].value,
                inputValues[3].value,
                inputValues[4].value,
                inputValues[5].value
            ]
        };
        const setDataFunction = memberSetting === 'everyStudent'
            ? setEveryStudentData
            : memberSetting === 'oneByOne'
                ? setOneByOneData
                : memberSetting === 'excelUpload'
                    ? setExcelUploadData
                    : null;
        if (setDataFunction) {
            setDataFunction(prev => [...(prev || []), newMember]);
        }
        // Reset input values
        setInputValues(substitutes.map(type => ({ type, value: '' })));
    };
    // 한 건씩 추가 - 수신자 선택 팝업
    const handlerOpenMemberList = () => {
        const checkedList = receiverMemberList.filter(item => originalStudentData.some(original => original.id === item.id)).map(item => item.id);
        APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
            className: 'send-popup',
            component: ChoiceMemberTable_1.ChoiceMemberList,
            componentProps: {
                memberSetting: memberSetting,
                noNumberData: noNumberData,
                checkedList: checkedList,
                memberList: originalStudentData,
                isNotChecked: false,
                isPopup: true,
                isNormal: true,
                isRegist: true,
            },
            width: isNormal ? 580 : 730,
            title: '수신자 목록',
            isFit: true,
        });
    };
    const renderTitle = (0, react_1.useMemo)(() => (react_1.default.createElement(SendMemberHeader_1.SendMemberHeader, { searchOption: searchOption.keyword, handlerFilterList: handlerFilterList, handlerDelete: handlerDelete, isOnlyStudent: isOnlyStudent, setIsOnlyStudent: setIsOnlyStudent, showOnlyStudentCheckbox: true, 
        // '수강생(전체)'은 체크된 인원수를 수신자 인원으로 표기, 그 외는 전체 인원수 표기
        totalTableList: isEveryStudent ? checkList.length : totalCount, isPopup: false, 
        // '수강생(전체)'은 체크박스가 수신자 선택 용도이므로 '선택 삭제' 버튼 숨김
        isRegist: !isEveryStudent })), [
        searchOption,
        totalCount,
        checkList,
        handlerFilterList,
        handlerDelete,
        isOnlyStudent,
        isEveryStudent,
    ]);
    const formatPhoneNumber = (phone) => {
        if (!phone)
            return "-";
        return phone.replace(/^(\d{3})(\d{4})(\d{4})$/, "$1-$2-$3");
    };
    const renderItem = (item, styles) => {
        if (isMobile)
            return tableReadDataKeys.map((headItem, index) => (react_1.default.createElement("p", { className: "overText2" },
                index === 1 ? formatPhoneNumber(item.data[index]) : item.data[index] || "-",
                index < tableReadDataKeys.length - 1 && " / ")));
        return tableReadDataKeys.map((headItem, index) => (react_1.default.createElement("div", { key: headItem.title, className: "body-item", style: {
                flex: !isMobile && headItem.space,
                ...styles?.bodyItem,
            } },
            react_1.default.createElement("p", { className: "overText2" }, index === 1 ? formatPhoneNumber(item.data[index]) : item.data[index] || "-"))));
    };
    const handleChange = value => {
        if (/^[\d]*$/.test(value)) {
            setInputValues(prev => {
                const newInputValues = [...prev];
                newInputValues[1].value = value;
                return newInputValues;
            });
        }
        else if (/^[\d-]*$/.test(value)) {
            alert((0, i18next_1.t)('sendSMS.excludeBar'));
        }
        else {
            alert((0, i18next_1.t)('sendSMS.onlyNumber'));
        }
    };
    const handleInputChange = (index, newValue) => {
        if (index === 1) {
            handleChange(newValue);
        }
        else {
            setInputValues(prev => prev.map((item, i) => i === index ? { ...item, value: newValue } : item));
        }
    };
    const renderMembersTableHeader = (0, react_1.useMemo)(() => {
        return (react_1.default.createElement("div", { className: "header" },
            react_1.default.createElement("div", { className: "field-global-001", style: { flexDirection: isMobile && 'column' } },
                react_1.default.createElement("div", { className: "fext-field", style: { flexDirection: isMobile && !isNormal && 'column' } }, isNormal ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(common_1.InputElement, { className: "add-input", type: "text", placeholder: "\uC774\uB984", value: inputValues[0]?.value || '', onChange: (value) => handleInputChange(0, value), style: { flex: 1 } }),
                    react_1.default.createElement(common_1.InputElement, { className: "add-input", type: "text", placeholder: "\uC804\uD654\uBC88\uD638", value: inputValues[1]?.value || '', onChange: (value) => handleChange(value), style: { flex: 2, minWidth: '102px' } }))) : (isMobile ? (react_1.default.createElement(react_1.default.Fragment, null, inputValues.reduce((rows, item, index) => {
                    if (index % 3 === 0)
                        rows.push([]); // Start a new row every 3 items
                    rows[rows.length - 1].push(react_1.default.createElement(common_1.InputElement, { key: index, className: "substitute-input", type: "text", placeholder: item.type, value: item.value, onChange: (value) => handleInputChange(index, value), style: { flex: 1, minWidth: '30%' } }));
                    return rows;
                }, []).map((row, rowIndex) => (react_1.default.createElement("div", { key: rowIndex, style: { display: 'flex', gap: '10px' } }, row))))) : (inputValues.map((item, index) => (react_1.default.createElement(common_1.InputElement, { key: index, className: "substitute-input", type: "text", placeholder: item.type, value: item.value, onChange: (value) => handleInputChange(index, value), style: !isMobile && index === 1 ? { minWidth: '102px' } : {} })))))),
                react_1.default.createElement("div", { className: "field-global-001", style: { width: isMobile ? '100%' : 'auto' } },
                    react_1.default.createElement(common_1.Button, { className: "btn_tur xmd", text: "\uCD94\uAC00", onClick: handlerAdd, styles: {
                            buttonWrap: {
                                flex: isMobile && '1',
                            },
                        } }),
                    isNormal && memberSetting !== "excelUpload" && memberSetting !== "everyStudent" && (react_1.default.createElement(common_1.Button, { className: "btn_tur xmd", text: (0, i18next_1.t)('sendSMS.selectMember'), onClick: handlerOpenMemberList, styles: {
                            buttonWrap: {
                                flex: isMobile && '1',
                            },
                        } }))))));
    }, [isNormal, memberSetting, setInputValues, isMobile, handleChange, inputValues, handleInputChange, handlerAdd, handlerOpenMemberList, originalStudentData, everyStudentData, oneByOneData, receiverMemberList, setReceiverMemberList]);
    // '수강생(전체)' 모드에서 전체 선택 가능한(번호 보유) 인원 ID 목록 (페이지네이션 무관 전체 인원)
    const selectableEveryStudentIds = react_1.default.useMemo(() => {
        const noNumberIds = new Set(noNumberData.map(item => item.id));
        return everyStudentData
            .filter(item => !noNumberIds.has(item.id))
            .map(item => item.id);
    }, [everyStudentData, noNumberData]);
    // 현재 페이지에 보이는 인원 ID (체크 병합 시 off-page 선택 보존용)
    const currentPageIds = react_1.default.useMemo(() => testData.map(item => item.id), [testData]);
    // 체크 리스트 변경 핸들러
    // - '수강생(전체)': Table은 현재 페이지 기준으로만 보고하므로,
    //   다른 페이지 선택 상태를 보존하며 현재 페이지 선택만 갱신한다.
    // - 그 외 모드: 기존대로 '선택 삭제'용 체크 리스트로 사용.
    const handlerCheckListChange = (list) => {
        if (!isEveryStudent) {
            setCheckList(list);
            return;
        }
        const currentPageSet = new Set(currentPageIds);
        setCheckList(prev => {
            // 현재 페이지 이외의 선택은 그대로 유지
            const offPage = prev.filter(id => !currentPageSet.has(id));
            // 현재 페이지에서 새로 체크된 항목만 반영
            const onPage = list.filter(id => currentPageSet.has(id));
            const next = Array.from(new Set([...offPage, ...onPage]));
            // 값이 같으면 동일 참조 반환 (defaultCheckList 재시드로 인한 무한 루프 방지)
            if (lodash_1.default.isEqual([...prev].sort(), [...next].sort()))
                return prev;
            return next;
        });
    };
    // 최상단 전체 체크박스 (페이지네이션 무관 클래스 전체 인원 선택/해제)
    const handlerFixedAllChecked = (checked) => {
        if (!isEveryStudent)
            return;
        setCheckList(checked ? selectableEveryStudentIds : []);
    };
    return (react_1.default.createElement(MemberListStyled, { "$isMobile": isMobile, "$isTablet": isTablet, "$isDesktop": isDesktop, className: `open-member-list` },
        react_1.default.createElement("div", { className: "member-setting" },
            react_1.default.createElement("div", { className: "setting-checkbox" },
                react_1.default.createElement("p", { className: "overText", style: { flexShrink: 0 } }, (0, i18next_1.t)('sendSMS.setMember')),
                react_1.default.createElement(common_1.CheckBox, { iconSize: isDesktop ? 24 : 20, isRadioButton: true, list: isNormal ? constant_1.SMS_MEMBER_CHECK_LIST : constant_1.SMS_MEMBER_CHECK_LIST.slice(1, 3), defaultCheckId: memberSetting, handlerCheck: (id, checked) => {
                        setMemberSetting(id);
                    } })),
            react_1.default.createElement("div", { className: "excel-wrap", style: { display: memberSetting === 'excelUpload' ? 'flex' : 'none' } },
                react_1.default.createElement(SMSUploadExcel_1.SMSUploadExcel, { receiverMemberList: receiverMemberList, setExcelUploadData: setExcelUploadData }))),
        react_1.default.createElement("div", { className: "member-list" },
            renderMembersTableHeader,
            react_1.default.createElement("div", { className: "member-wrap" },
                react_1.default.createElement(MemberListTableStyled_1.MembersTableStyled, { "$isMobile": isMobile, "$isTablet": isTablet, className: "user-list" },
                    renderTitle,
                    react_1.default.createElement(common_1.Table, { className: "sms-member-list", forceShowheader: true, showCheckBox: true, 
                        // '수강생(전체)'은 체크 리스트를 MemberList가 소유하여 표시한다.
                        defaultCheckList: isEveryStudent ? checkList : undefined, isSMS: isEveryStudent, disableIdList: noNumberData.map(item => item.id), isInfinite: false, data: testData, totalCount: totalCount, page: page, pagingCount: 5, showCount: count, sortDefault: "id", headTitleList: headTitleList, renderItem: renderItem, handlerCheckList: handlerCheckListChange, setFixedAllChecked: isEveryStudent ? handlerFixedAllChecked : undefined, handlerMoreData: handlerMoreData, isKeepChecked: true, renderGuidItem: react_1.default.createElement(react_1.default.Fragment, null), padding: false }))))));
});
